import { render } from "./downloadComponent.vue?vue&type=template&id=35368ba6"
import script from "./downloadComponent.vue?vue&type=script&lang=js"
export * from "./downloadComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__